import { createContext } from "react";
import RecurrentPaymentsActionsInterface from "./types";

const RecurrentPaymentActionsContext =
  createContext<RecurrentPaymentsActionsInterface>({
    approveHHRREducation: () => {},
    approveHHRREducationIsLoading: false,

    approveFinanceEducation: () => {},
    approveFinanceEducationIsLoading: false,

    reviewRentingDetails: () => {},
    reviewRentingDetailsIsLoading: false,

    approveRenting: () => {},
    approveRentingIsLoading: false,

    rejectEducation: () => {},
    rejectEducationIsLoading: false,

    rejectRenting: () => {},
    rejectRentingIsLoading: false,

    downloadRentingFile: () => {},

    sendReportEmail: () => {},
  });

export default RecurrentPaymentActionsContext;
